import extractUserFromLocalStorage from "../Service/jwtUtils";

const SUPER_ADMIN_VALUES = new Set([
  "SuperUser",
  "SuperAdmin",
]);

export const isSuperAdmin = (userDetails) => {
  const tokenUser = extractUserFromLocalStorage();
  const candidates = [
    userDetails?.userRole,
    tokenUser?.userRole,
  ];

  return candidates.some((value) => SUPER_ADMIN_VALUES.has(value));
};
